// src/pages/BillingCancel.jsx

import { useNavigate } from "react-router-dom";
import "./BillingCancel.css";

export default function BillingCancel() {
  const navigate = useNavigate();

  return (
    <main className="billing-cancelled-page">
      <section
        className="billing-cancelled-card"
        aria-labelledby="billing-cancelled-title"
      >
        <div className="billing-cancelled-icon" aria-hidden="true">
          <i className="bi bi-x-lg" />
        </div>

        <div className="billing-cancelled-content">
          <span className="billing-cancelled-label">Checkout cancelled</span>

          <h1 id="billing-cancelled-title">No subscription was created</h1>

          <p>
            Your checkout session was safely cancelled and your fleet remains
            unchanged. You can subscribe whenever you’re ready.
          </p>
        </div>

        <div className="billing-cancelled-plan">
          <div className="billing-cancelled-plan-header">
            <div className="billing-cancelled-plan-icon">
              <i className="bi bi-truck" aria-hidden="true" />
            </div>

            <div>
              <span>Vehicle Subscription</span>
              <strong>$30/month per truck</strong>
            </div>
          </div>

          <div className="billing-cancelled-plan-note">
            <i className="bi bi-info-circle" aria-hidden="true" />

            <span>Billing excludes GST</span>
          </div>
        </div>

        <div className="billing-cancelled-status">
          <i className="bi bi-shield-check" aria-hidden="true" />

          <div>
            <strong>Your account is safe</strong>

            <span>No payment was processed during this checkout attempt.</span>
          </div>
        </div>

        <div className="billing-cancelled-actions">
          <button
            type="button"
            className="billing-cancelled-primary"
            onClick={() =>
              navigate("/fleetmanager", {
                replace: true,
              })
            }
          >
            <i className="bi bi-truck" aria-hidden="true" />

            <span>Manage Vehicles</span>
          </button>

          {/* <button
            type="button"
            className="billing-cancelled-secondary"
            onClick={() =>
              navigate("/billing-plans", {
                replace: true,
              })
            }
          >
            <i className="bi bi-credit-card" aria-hidden="true" />

            <span>Review Subscription</span>
          </button> */}
        </div>

        <button
          type="button"
          className="billing-cancelled-dashboard"
          onClick={() =>
            navigate("/", {
              replace: true,
            })
          }
        >
          <i className="bi bi-arrow-left" aria-hidden="true" />

          <span>Return to Dashboard</span>
        </button>
      </section>
    </main>
  );
}
